import React from "react";

export default function VrodexIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      version="1.1"
      viewBox="0 0 1256.4 1161.2"
      x="0px"
      y="0px"
    >
      <rect className="hidden" />
      <g>
        <g>
          <polygon
            className="fill-[#36C6F4]"
            points="526.9,580.6 359.5,580.6 19.2,233 186.7,233 516.3,569.8 		"
          />
          <polygon
            className="fill-[#32B2EF]"
            points="526.9,580.6 491.6,616.7 325.2,786.6 157.7,786.6 359.3,580.6 		"
          />
        </g>
        <g>
          <polygon
            className="fill-[#2063DB]"
            points="1059.6,396.4 875.9,580.6 706.9,580.6 722.8,564.6 890.7,396.4 		"
          />
          <polygon
            className="fill-[#2577E0]"
            points="1237.2,942.8 1068.1,942.8 735.6,609.4 706.9,580.6 875.9,580.6 		"
          />
        </g>
        <g>
          <polygon
            className="fill-[#5A57E2]"
            points="616.9,381.2 616.9,550.6 511.2,444.7 99,31.4 268,31.4 		"
          />
          <polygon
            className="fill-[#4554DE]"
            points="1016.7,149.8 722.5,444.7 616.9,550.6 616.9,381.2 847.7,149.8 		"
          />
        </g>
        <g>
          <polygon
            className="fill-[#298AE5]"
            points="1134.8,1129.8 965.8,1129.8 617,780.2 617,610.7 722.5,716.5 		"
          />
          <polygon
            className="fill-[#2D9EEA]"
            points="617,610.7 617,780.2 616.9,780 386.1,1011.4 217.1,1011.4 511.3,716.5 616.9,610.6 		"
          />
        </g>
      </g>
    </svg>
  );
}
